goog.provide("shadow.js.shim.module$$embedpdf$plugin_render");
goog.provide("module$shadow_js_shim_module$$embedpdf$plugin_render");
shadow.js.shim.module$$embedpdf$plugin_render = shadow.js.nativeProvides["@embedpdf/plugin-render"] = shadow$bridge("@embedpdf/plugin-render");
module$shadow_js_shim_module$$embedpdf$plugin_render.default = shadow.js.shim.module$$embedpdf$plugin_render;
